// extracted by mini-css-extract-plugin
module.exports = {"dialogBox":"DialogBox_dialogBox__NO7N4"};